import { render, staticRenderFns } from "./ChavesApi.vue?vue&type=template&id=496f5231"
import script from "./ChavesApi.vue?vue&type=script&lang=js"
export * from "./ChavesApi.vue?vue&type=script&lang=js"
import style0 from "./ChavesApi.vue?vue&type=style&index=0&id=496f5231&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports